module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-locked-cd4a5a28b592041606222d865830db49.svg";